// Single source of truth for currency choices across the app.
// Add new currencies here and they will appear in Settings, Onboarding, and Subscription.
export const CURRENCIES = [
  ['AED', 'AED', 'UAE Dirham'],
  ['SAR', 'SAR', 'Saudi Riyal'],
  ['QAR', 'QAR', 'Qatari Riyal'],
  ['OMR', 'OMR', 'Omani Rial'],
  ['BHD', 'BHD', 'Bahraini Dinar'],
  ['KWD', 'KWD', 'Kuwaiti Dinar'],
  ['EGP', 'E£', 'Egyptian Pound'],
  ['USD', '$', 'US Dollar'],
  ['EUR', '€', 'Euro'],
  ['GBP', '£', 'British Pound'],
  ['INR', '₹', 'Indian Rupee'],
  ['PKR', '₨', 'Pakistani Rupee'],
  ['CAD', 'C$', 'Canadian Dollar'],
  ['AUD', 'A$', 'Australian Dollar'],
  ['ZAR', 'R', 'South African Rand'],
  ['JPY', '¥', 'Japanese Yen'],
  ['CNY', '¥', 'Chinese Yuan'],
  ['KES', 'KSh', 'Kenyan Shilling'],
  ['NGN', '₦', 'Nigerian Naira'],
];

export const CURRENCY_SYMBOLS = Object.fromEntries(CURRENCIES.map(([code, sym]) => [code, sym]));

export function symbolFor(code) {
  return CURRENCY_SYMBOLS[code] || code;
}
